import { render, staticRenderFns } from "./InspectResult.vue?vue&type=template&id=22669d02&scoped=true"
import script from "./InspectResult.vue?vue&type=script&lang=js"
export * from "./InspectResult.vue?vue&type=script&lang=js"
import style0 from "./InspectResult.vue?vue&type=style&index=0&id=22669d02&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22669d02",
  null
  
)

export default component.exports